import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import Button from '@active/react-ui/Button'
import ButtonGroup from '@active/react-ui/ButtonGroup'
import { NewCreditCardForm } from '../../../payments/components/CreditCard'
import PaymentAlias from '../../../payments/components/common/PaymentAlias'
import I18nMessage from '../../../common/I18nMessage'
import { reduceFalseProp } from '../../../../shared/utils/commonUtils'
import '../wallet.components.scss'
import './NewCreditCard.scss'

class NewCreditCard extends PureComponent {
  static propTypes = {
    getNewCreditCardConfig: func.isRequired,
    addCreditCard: func.isRequired,
    setErrorMsg: func.isRequired,
    handleBackView: func.isRequired,
    updatePaymentInfoList: func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      paymentServiceURL: '',
      url: '',
      displayName: '',
    }
  }

  componentDidMount() {
    this.initData()
  }

  getPaymentAliasCallBack = value => {
    this.setState({
      displayName: value,
    })
  }

  getNewCreditCardCallBack = ({
    result, sessionId, address, billingFirstName, billingLastName,
  }) => {
    const { addCreditCard, setErrorMsg, updatePaymentInfoList } = this.props
    const { displayName } = this.state
    if (result === 'action_success') {
      const params = {
        postResource: 'wallet',
        sessionId,
        displayName: displayName || null,
        billingFirstName,
        billingLastName,
        address: reduceFalseProp({
          ...address,
          countryCode: address && address.country ? address.country : null,
        }),
      }
      addCreditCard({
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
        },
        params,
        resolve: res => {
          if (res.status === 'FAILURE') {
            setErrorMsg(res.message, res.errorCode)
          } else {
            updatePaymentInfoList()
            setErrorMsg(null, null, true)
          }
        },
        reject: ({ message, errorCode }) => {
          setErrorMsg(message, errorCode)
        },
      })
    } else {
      setErrorMsg(null, null, true)
    }
  }

  initData = () => {
    const { getNewCreditCardConfig, setErrorMsg } = this.props
    getNewCreditCardConfig({
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
      },
      resolve: ({
        paymentServiceURL, url, message, status, errorCode,
      }) => {
        if (status === 'FAILURE' && message) {
          setErrorMsg(message, errorCode)
        } else {
          this.setState({
            paymentServiceURL,
            url,
          })
          setErrorMsg(null, null, true)
        }
      },
      reject: ({ message, errorCode }) => {
        setErrorMsg(message, errorCode)
      },
    })
  }

  handleClick = () => {
    this.newCreditCardForm.submitData()
  }

  handleCancel = () => {
    const { handleBackView } = this.props
    handleBackView()
  }

  render() {
    const { paymentServiceURL, url } = this.state
    return (
      <div className="passport__wallet__new-creditcard passport__wallet__detail-component passport__wallet__components">
        <h1 className="passport__wallet__new-creditcard__title passport__wallet__component-title">
          <I18nMessage id="passport.wallet.newCreditCard.title" />
        </h1>
        {
          paymentServiceURL
          && (
          <NewCreditCardForm
            hostName={paymentServiceURL}
            dataSourceUrl={url}
            ref={b => { this.newCreditCardForm = b }}
            getNewCreditCardCallBack={this.getNewCreditCardCallBack}
          />
          )
        }
        <PaymentAlias getPaymentAliasCallBack={this.getPaymentAliasCallBack} />
        <ButtonGroup horizontal className="grid passport__wallet__btn">
          <Button type="primary" onClick={this.handleClick}>
            <I18nMessage id="passport.wallet.create.add" />
          </Button>
          <Button type="secondary" onClick={this.handleCancel}>
            <I18nMessage id="passport.common.btn.cancel" />
          </Button>
        </ButtonGroup>
      </div>
    )
  }
}

export default NewCreditCard
